import { MediaTypeDefaultAttributeDTO } from 'features/inventory/ad-unit/api/types/mediaTypesDTO'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const MEDIA_TYPE_FRAGMENT = `
    bannerEnabled
    bannerSizes
    nativeEnabled
    videoEnabled
    playerSize
`
export const MEDIA_TYPE_FOR_FORM_FRAGMENT: TypedDocumentNode<MediaTypeDefaultAttributeDTO> = gql`
  fragment MediaTypeForFormFragment on MediaType {
    id
    updatedAt
    ${MEDIA_TYPE_FRAGMENT}
  }
`
